import {
  ActionIcon,
  Badge,
  Button,
  Card,
  Group,
  Image,
  Text,
} from "@mantine/core";
import classes from "./GridItem.module.css";
import { IconCoins, IconHeart } from "@tabler/icons-react";
import { GridItemProps, ProductPlansData } from "../../../types/types";
import { useDisclosure } from "@mantine/hooks";
import { SubscriptionModal } from "../SubscriptionModal/SubscriptionModal";
import { useState } from "react";
import { ProductModal } from "../ProductModal/ProductModal";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { MangPaymentModal } from "../MangPaymentModal/MangPaymentModal";

export default function GridItem(props: GridItemProps) {
  // Hook for managing modal.
  const [opened, { open, close }] = useDisclosure(false);
  const [openedMngPay, { open: openMngPay, close: closeMngPay }] =
    useDisclosure(false);
  const [fields, setFields] = useState({
    planName: "",
    subNum: "",
    total: "",
    status: "",
    lBillDate: "",
    nBillDate: "",
    subID: "",
  });
  const [productDataMap, setProductDataMap] = useState<ProductPlansData[]>([]);
  const [loading, setLoading] = useState(false);
  const isSubscription = props.type === "subscriptions";

  let title: string = "";
  let subtitle: string = "";
  let pillLabel: string = "";
  let buttonLabel: string = "";

  // Populate grid items
  title = props.data.Name;
  pillLabel = props.data.Status ?? "";

  if (isSubscription) {
    subtitle = `Total: ${props.data.Currency_Symbol ?? ""}${props.data.Total ?? ""
      }`;
    buttonLabel = "Details";
  } else {
    subtitle = props.data.Description ?? "";
    buttonLabel = "View Plans";
  }

  // Compute data for modal
  async function handleModalOpen() {
    setLoading(true);
    if (isSubscription) {
      // Show extra data from the original subscription call
      setFields(
        // Subscription modal data
        {
          planName: props.data.Plan_Name ?? "—",
          subNum: props.data.Subscription_Number,
          total: `${props.data.Currency_Symbol}${props.data.Total}`,
          status: props.data.Status ?? "—",
          lBillDate: props.data.Last_Billing_Date ?? "—",
          nBillDate: props.data.Next_Billing_Date ?? "—",
          subID: props.data.Subscription_ID,
        }
      );
      open();
      setLoading(false);
    } else {
      try {
        const response = await fetch(
          window.location.origin +
          "/server/client_service/plans" +
          "/" +
          props.data.Product_Id
        );
        const resJson = await response.json();
        console.log("Resarray is ", resJson);
        setProductDataMap(resJson);
      } catch (err) {
        console.error(err);
      } finally {
        open();
        setLoading(false);
      }
    }
  }

  function handleMangPayment() {
    openMngPay();
  }

  return (
    <Card withBorder radius="md" p="md" className={classes.card}>
      <Card.Section>
        <Image src={props.image.src} alt={props.image.alt} height={180} />
      </Card.Section>

      <Card.Section className={classes.section} mt="md">
        <Group justify="space-between">
          <Text fz="lg" fw={500}>
            {title}
          </Text>
          <Badge size="sm" variant="outline" mb="sm">
            {pillLabel}
          </Badge>
        </Group>
        <Group justify="space-between">
          <Text fz="sm" mt="xs">
            {subtitle}
          </Text>
          {isSubscription ? (
            <>
              <Button
                variant="light"
                size="xs"
                radius="xl"
                onClick={handleMangPayment}
                style={{ backgroundColor: "#00ddb3", color: "white" }}
              > <IconCoins style={{ paddingRight: 2 }} size={18} stroke={2.5} />
                Manage Payment
              </Button>
              <MangPaymentModal
                opened={openedMngPay}
                close={closeMngPay}
                subId={props.data.Subscription_ID}
              />
            </>
          ) : null}
        </Group>
      </Card.Section>

      <Group mt="xs">
        <Button
          variant="gradient"
          gradient={{ from: "#00ddb3", to: "#00ddb3", deg: 125 }}
          radius="md"
          style={{ flex: 1 }}
          onClick={handleModalOpen}
        >
          {loading ? <LoadingSpinner size="sm" color="white" /> : buttonLabel}
        </Button>
        {isSubscription ? (
          <SubscriptionModal
            opened={opened}
            close={close}
            title={title}
            fields={fields}
          />
        ) : (
          <ProductModal opened={opened} closed={close} data={productDataMap} />
        )}
      </Group>
    </Card>
  );
}
